import snakecaseKeys from 'snakecase-keys'
import axiosIns from '@/plugins/axios'

export default {
  getAggregations(date, options = {}) {
    const { forceReload = false } = options

    return axiosIns.get(
      '/v2/eod_closing/aggregations',
      { params: snakecaseKeys({ date, forceReload }) },
    )
  },
  enqueueAggregation(id, date, options = {}) {
    const { forceReload = false, forceRefresh = false } = options

    return axiosIns.get(
      `/v2/eod_closing/aggregations/${id}/enqueue`,
      { params: snakecaseKeys({ date, forceReload, forceRefresh }) },
    )
  },
  // withPayrollSummary: true のときのみ給与サマリー計算列（総支給額・総控除額・差引支給額・残り支給額・源泉）を
  // 取得する。日報ベータ（eod-closing-v2 とその CSV）でのみ指定し、従来の日報では指定しない＝列が付かない。
  getAggregationJobStatus(id, date, options = {}) {
    const { withPayrollSummary = false } = options

    return axiosIns.get(
      `/v2/eod_closing/aggregations/${id}/status`,
      { params: snakecaseKeys({ date, withPayrollSummary }) },
    )
  },
  getAvailableUsers(id) {
    return axiosIns.get(`/v2/eod_closing/aggregations/${id}/available_users`)
  },
  // 指定 type の集計表を依存順に「リセット→再集計→保存」する一括処理を起動する。
  // バックエンドは container_id または type を受ける。今は type を渡す（互換パス）。
  // aggregationIds（配列）を渡すと、その集計表だけを対象にした部分集計を起動する
  // （個別集計＝要素1／「完了する」の完了済みスキップ＝未完了 ID 群）。
  // 未指定（null / 空配列）なら全表示対象を実行する（force-all）。
  bulkComplete(type, date, aggregationIds = null) {
    const hasIds = Array.isArray(aggregationIds) && aggregationIds.length > 0

    return axiosIns.post(
      '/v2/eod_closing/aggregations/bulk_complete',
      snakecaseKeys({ type, date, ...(hasIds ? { aggregationIds } : {}) }),
    )
  },
  // 一括処理の進捗・各集計表の状態を取得する。
  getBulkCompleteStatus(jobId) {
    return axiosIns.get(`/v2/eod_closing/aggregations/bulk_complete/${jobId}`)
  },
}
